import {
  ADD_THIN_FILE_STORAGE,
  REMOVE_THIN_FILE_STORAGE
} from '../types/thinFile.constants';


export const addThinfileStorage = (isThreeBPropertyExist, threeBEnrollmentFail, threeBEnrollmentFailType, threeBEnrollmentFailMessage) => {
  return { 
    type: ADD_THIN_FILE_STORAGE,
    isThreeBPropertyExist,
    threeBEnrollmentFail,
    threeBEnrollmentFailType,
    threeBEnrollmentFailMessage
  };
}

export const removeThinfileStorage = () => {
  return { type: REMOVE_THIN_FILE_STORAGE };
}
